const monthNames = [
  'Januar',
  'Februar',
  'Marts',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'December',
];

export const months = ['Alle', ...monthNames];

export const regions = [
  'Alle',
  'Hovedstaden',
  'Sjælland',
  'Fyn',
  'Jylland',
  'Bornholm',
  'Flere landsdele',
];

export const formatFestivalDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  const sameMonth = start.getMonth() === end.getMonth();
  const startMonth = monthNames[start.getMonth()].toLowerCase();
  const endMonth = monthNames[end.getMonth()].toLowerCase();

  if (sameMonth) {
    return `${start.getDate()}. - ${end.getDate()}. ${startMonth} ${end.getFullYear()}`;
  }

  return `${start.getDate()}. ${startMonth} - ${end.getDate()}. ${endMonth} ${end.getFullYear()}`;
};

export const getMonthLabelFromDate = (dateString) => monthNames[new Date(dateString).getMonth()];

export const getApproxVisitorsValue = (approxVisitors) =>
  Number.parseInt((approxVisitors || '0').replace(/\D/g, ''), 10) || 0;

const genericFestivalImage = 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=1200&q=80';
const cityFestivalImage = 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&q=80';
const rockFestivalImage = 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=1200&q=80';

export const festivals = [
  {
    id: 'roskilde-festival',
    name: 'Roskilde Festival',
    city: 'Roskilde',
    region: 'Sjælland',
    startDate: '2026-06-27',
    endDate: '2026-07-04',
    approxVisitors: '130.000+',
    website: 'https://www.roskilde-festival.dk',
    instagram: 'https://www.instagram.com/roskildefestival/',
    facebook: 'https://www.facebook.com/roskildefestival',
    image: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=1200&q=80',
    genres: ['Musik', 'Storfestival'],
    featured: true,
    lat: 55.6419,
    lng: 12.0803,
  },
  {
    id: 'smukfest',
    name: 'Smukfest',
    city: 'Skanderborg',
    region: 'Jylland',
    startDate: '2026-08-02',
    endDate: '2026-08-09',
    approxVisitors: '55.000+',
    website: 'https://smukfest.dk',
    instagram: 'https://www.instagram.com/smukfest/',
    facebook: 'https://www.facebook.com/smukfest',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&q=80',
    genres: ['Musik', 'Storfestival'],
    featured: true,
    lat: 56.0337,
    lng: 9.9278,
  },
  {
    id: 'tinderbox',
    name: 'Tinderbox',
    city: 'Odense',
    region: 'Fyn',
    startDate: '2026-06-25',
    endDate: '2026-06-27',
    approxVisitors: '45.000',
    website: 'https://tinderbox.dk',
    instagram: 'https://www.instagram.com/tinderboxdk/',
    facebook: 'https://www.facebook.com/Tinderboxfestival',
    image: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=1200&q=80',
    genres: ['Musik', 'Storfestival'],
    featured: true,
    lat: 55.3898,
    lng: 10.3421,
  },
  {
    id: 'northside',
    name: 'NorthSide',
    city: 'Aarhus',
    region: 'Jylland',
    startDate: '2026-06-04',
    endDate: '2026-06-06',
    approxVisitors: '35.000',
    website: 'https://northside.dk',
    instagram: 'https://www.instagram.com/northsidefestival/',
    facebook: 'https://www.facebook.com/northsidefestival',
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=1200&q=80',
    genres: ['Musik', 'Storfestival'],
    featured: true,
    lat: 56.1496,
    lng: 10.2039,
  },
  {
    id: 'copenhell',
    name: 'Copenhell',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-06-17',
    endDate: '2026-06-20',
    approxVisitors: '25.000+',
    website: 'https://www.copenhell.dk',
    instagram: 'https://www.instagram.com/copenhell/',
    facebook: 'https://www.facebook.com/copenhell',
    image: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=1200&q=80',
    genres: ['Metal', 'Rock'],
    featured: true,
    lat: 55.6929,
    lng: 12.5993,
  },
  {
    id: 'heartland',
    name: 'Heartland',
    city: 'Kværndrup',
    region: 'Fyn',
    startDate: '2026-06-18',
    endDate: '2026-06-20',
    approxVisitors: '20.000',
    website: 'https://www.heartlandfestival.dk',
    instagram: 'https://www.instagram.com/heartlandfestival/',
    facebook: 'https://www.facebook.com/heartlandfestival',
    image: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=1200&q=80',
    genres: ['Musik', 'Kultur'],
    featured: true,
    lat: 55.1782,
    lng: 10.5258,
  },
  {
    id: 'nibe-festival',
    name: 'Nibe Festival',
    city: 'Nibe',
    region: 'Jylland',
    startDate: '2026-07-01',
    endDate: '2026-07-04',
    approxVisitors: '25.000',
    website: 'https://www.nibefestival.dk',
    instagram: 'https://www.instagram.com/nibefestival/',
    facebook: 'https://www.facebook.com/nibefestival',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1200&q=80',
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.9818,
    lng: 9.6392,
  },
  {
    id: 'musik-i-lejet',
    name: 'Musik i Lejet',
    city: 'Tisvildeleje',
    region: 'Hovedstaden',
    startDate: '2026-07-16',
    endDate: '2026-07-18',
    approxVisitors: '10.000+',
    website: 'https://musikilejet.dk',
    instagram: 'https://www.instagram.com/musikilejet/',
    facebook: 'https://www.facebook.com/musikilejet',
    image: 'https://images.unsplash.com/photo-1501612780327-45045538702b?w=1200&q=80',
    genres: ['Musik', 'Sommerfestival'],
    featured: false,
    lat: 56.0553,
    lng: 12.0656,
  },
  {
    id: 'musik-i-gentofte',
    name: 'Musik i Gentofte',
    city: 'Gentofte',
    region: 'Hovedstaden',
    startDate: '2026-07-25',
    endDate: '2026-07-26',
    approxVisitors: null,
    website: 'https://www.musikigentofte.dk',
    instagram: 'https://www.instagram.com/musikigentofte/',
    facebook: 'https://www.facebook.com/musikigentofte',
    image: '/musikigentofte.jpg',
    genres: ['Musik', 'Byfestival'],
    featured: false,
    lat: 55.7524,
    lng: 12.5416,
  },
  {
    id: 'spot-festival',
    name: 'SPOT Festival',
    city: 'Aarhus',
    region: 'Jylland',
    startDate: '2026-05-01',
    endDate: '2026-05-02',
    approxVisitors: '12.000',
    website: 'https://spotfestival.dk',
    instagram: 'https://www.instagram.com/spotfestival/',
    facebook: 'https://www.facebook.com/spotfestivalaarhus',
    image: 'https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=1200&q=80',
    genres: ['Musik', 'Showcase'],
    featured: false,
    lat: 56.1629,
    lng: 10.2039,
  },
  {
    id: 'jelling-musikfestival',
    name: 'Jelling Musikfestival',
    city: 'Jelling',
    region: 'Jylland',
    startDate: '2026-05-21',
    endDate: '2026-05-24',
    approxVisitors: '40.000',
    website: 'https://jellingmusikfestival.dk',
    instagram: 'https://www.instagram.com/jellingmusikfestival/',
    facebook: 'https://www.facebook.com/jellingmusikfestival',
    image: 'https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=1200&q=80',
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.7555,
    lng: 9.4258,
  },
  {
    id: 'skive-festival',
    name: 'Skive Festival',
    city: 'Skive',
    region: 'Jylland',
    startDate: '2026-06-04',
    endDate: '2026-06-07',
    approxVisitors: '12.000',
    website: 'https://skivefestival.dk',
    instagram: 'https://www.instagram.com/skivefestival/',
    facebook: 'https://www.facebook.com/skivefestival',
    image: 'https://images.unsplash.com/photo-1504704911898-68304a7d2807?w=1200&q=80',
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.5662,
    lng: 9.0273,
  },
  {
    id: 'toender-festival',
    name: 'Tønder Festival',
    city: 'Tønder',
    region: 'Jylland',
    startDate: '2026-08-27',
    endDate: '2026-08-30',
    approxVisitors: '15.000',
    website: 'https://tf.dk',
    instagram: 'https://www.instagram.com/toenderfestival/',
    facebook: 'https://www.facebook.com/toenderfestival',
    image: 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=1200&q=80',
    genres: ['Folk', 'Roots'],
    featured: false,
    lat: 54.9331,
    lng: 8.8667,
  },
  {
    id: 'bork-festival',
    name: 'Bork Festival',
    city: 'Hemmet',
    region: 'Jylland',
    startDate: '2026-07-29',
    endDate: '2026-08-01',
    approxVisitors: null,
    website: 'https://borkfestival.dk',
    instagram: 'https://www.instagram.com/borkfestival/',
    facebook: 'https://www.facebook.com/borkfestival',
    image: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?w=1200&q=80',
    genres: ['Musik', 'Sommerfestival'],
    featured: false,
    lat: 55.8482,
    lng: 8.2795,
  },
  {
    id: 'wonderfestiwall',
    name: 'Wonderfestiwall',
    city: 'Allinge',
    region: 'Bornholm',
    startDate: '2026-08-20',
    endDate: '2026-08-23',
    approxVisitors: '8.000+',
    website: 'https://wonderfestiwall.dk',
    instagram: 'https://www.instagram.com/wonderfestiwall/',
    facebook: 'https://www.facebook.com/wonderfestiwall',
    image: 'https://images.unsplash.com/photo-1499364615650-ec38552f4f34?w=1200&q=80',
    genres: ['Musik', 'Ø-festival'],
    featured: false,
    lat: 55.2767,
    lng: 14.8013,
  },
  {
    id: 'vi-elsker-90erne',
    name: "Vi elsker 90'erne",
    city: 'Flere byer',
    region: 'Flere landsdele',
    startDate: '2026-06-19',
    endDate: '2026-06-20',
    approxVisitors: '17.000',
    website: 'https://vielsker.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.2639,
    lng: 9.5018,
  },
  {
    id: 'hede-rytmer',
    name: 'Hede Rytmer',
    city: 'Silkeborg',
    region: 'Jylland',
    startDate: '2026-05-28',
    endDate: '2026-05-30',
    approxVisitors: '6.000',
    website: 'https://www.hederytmer.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.1697,
    lng: 9.5451,
  },
  {
    id: 'sjaellandsfestivalen',
    name: 'Sjællandsfestivalen',
    city: 'Slagelse',
    region: 'Sjælland',
    startDate: '2026-05-15',
    endDate: '2026-05-16',
    approxVisitors: '3.000',
    website: 'https://www.sjaellandsfestivalen.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.4028,
    lng: 11.3546,
  },
  {
    id: 'herning-rocker',
    name: 'Herning Rocker',
    city: 'Herning',
    region: 'Jylland',
    startDate: '2026-05-24',
    endDate: '2026-05-25',
    approxVisitors: '10.000',
    website: 'https://www.herning-rocker.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 56.1362,
    lng: 8.9766,
  },
  {
    id: 'distortion',
    name: 'Distortion',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-05-28',
    endDate: '2026-06-02',
    approxVisitors: '300.000',
    website: 'https://cphdistortion.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'sv-festival',
    name: 'SV Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-05-30',
    endDate: '2026-06-08',
    approxVisitors: null,
    website: 'https://online-store-web.shopifyapps.com',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'sommersol-paa-slottet',
    name: 'Sommersol på slottet',
    city: 'Charlottenlund',
    region: 'Hovedstaden',
    startDate: '2026-05-31',
    endDate: '2026-06-01',
    approxVisitors: null,
    website: 'https://sommersolpaaslottet.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.7517,
    lng: 12.5746,
  },
  {
    id: 'hornsrock-musikfestival',
    name: 'Hornsrock Musikfestival',
    city: 'Skibby',
    region: 'Sjælland',
    startDate: '2026-06-03',
    endDate: '2026-06-03',
    approxVisitors: null,
    website: 'https://www.hornsrock.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 55.7512,
    lng: 11.9608,
  },
  {
    id: 'rosenholm-festival',
    name: 'Rosenholm Festival',
    city: 'Hornslet',
    region: 'Jylland',
    startDate: '2026-06-05',
    endDate: '2026-06-07',
    approxVisitors: '6.000',
    website: 'https://www.rosenholm-festival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.3154,
    lng: 10.3204,
  },
  {
    id: 'haze-over-haarum',
    name: 'Haze over Haarum',
    city: 'Harboøre',
    region: 'Jylland',
    startDate: '2026-06-06',
    endDate: '2026-06-07',
    approxVisitors: '6.500',
    website: 'https://www.haze.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.6173,
    lng: 8.1802,
  },
  {
    id: 'nord-als-musikfestival',
    name: 'Nord-Als Musikfestival',
    city: 'Nordborg',
    region: 'Jylland',
    startDate: '2026-06-12',
    endDate: '2026-06-13',
    approxVisitors: '3.500',
    website: 'https://www.musikfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.0578,
    lng: 9.7403,
  },
  {
    id: 'rock-under-broen',
    name: 'Rock under broen',
    city: 'Middelfart',
    region: 'Fyn',
    startDate: '2026-06-06',
    endDate: '2026-06-07',
    approxVisitors: '20.000',
    website: 'https://rockunderbroen.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 55.5059,
    lng: 9.7305,
  },
  {
    id: 'skvulp-festival',
    name: 'Skvulp Festival',
    city: 'Holbæk',
    region: 'Sjælland',
    startDate: '2026-06-06',
    endDate: '2026-06-07',
    approxVisitors: null,
    website: 'https://www.skvulpfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.7181,
    lng: 11.7128,
  },
  {
    id: 'engage-festival',
    name: 'Engage Festival',
    city: 'Østerbro',
    region: 'Hovedstaden',
    startDate: '2026-06-06',
    endDate: '2026-06-07',
    approxVisitors: null,
    website: 'https://engagefestival.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.6997,
    lng: 12.5948,
  },
  {
    id: 'syd-for-solen',
    name: 'Syd For Solen',
    city: 'Frederiksberg',
    region: 'Hovedstaden',
    startDate: '2026-08-07',
    endDate: '2026-08-09',
    approxVisitors: '35.000',
    website: 'https://sydforsolen.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6786,
    lng: 12.5336,
  },
  {
    id: 'rock-i-frederikshavn',
    name: 'Rock i Frederikshavn',
    city: 'Frederikshavn',
    region: 'Jylland',
    startDate: '2026-06-08',
    endDate: '2026-06-08',
    approxVisitors: '3.500',
    website: 'https://www.rockifrederikshavn.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 57.4407,
    lng: 10.5366,
  },
  {
    id: 'blaavandshuk-musikfestival',
    name: 'Blåvandshuk Musikfestival',
    city: 'Blåvand',
    region: 'Jylland',
    startDate: '2026-06-08',
    endDate: '2026-06-08',
    approxVisitors: null,
    website: 'https://blaavandshukmusikfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.5586,
    lng: 8.1227,
  },
  {
    id: 'aarhus-jazz-festival',
    name: 'Aarhus Jazz Festival',
    city: 'Aarhus',
    region: 'Jylland',
    startDate: '2026-06-11',
    endDate: '2026-06-20',
    approxVisitors: null,
    website: 'https://jazzfest.dk',
    image: cityFestivalImage,
    genres: ['Jazz'],
    featured: false,
    lat: 56.1629,
    lng: 10.2039,
  },
  {
    id: 'soelund-festival',
    name: 'Sølund Festival',
    city: 'Skanderborg',
    region: 'Jylland',
    startDate: '2026-06-11',
    endDate: '2026-06-13',
    approxVisitors: '20.000',
    website: 'https://www.solundfestivalen.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.0337,
    lng: 9.9278,
  },
  {
    id: 'ikast-musikliv',
    name: 'Ikast Musikliv',
    city: 'Ikast',
    region: 'Jylland',
    startDate: '2026-06-14',
    endDate: '2026-06-15',
    approxVisitors: null,
    website: 'https://ikastmusikliv.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.1388,
    lng: 9.1577,
  },
  {
    id: 'kloeften-festival',
    name: 'Kløften Festival',
    city: 'Haderslev',
    region: 'Jylland',
    startDate: '2026-06-26',
    endDate: '2026-06-28',
    approxVisitors: '8.000',
    website: 'https://www.kloften.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.2494,
    lng: 9.487,
  },
  {
    id: 'thy-rock',
    name: 'Thy Rock',
    city: 'Thisted',
    region: 'Jylland',
    startDate: '2026-06-27',
    endDate: '2026-06-28',
    approxVisitors: '10.000',
    website: 'https://thyrock.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 56.9552,
    lng: 8.6949,
  },
  {
    id: 'vilde-vulkaner-festival',
    name: 'Vilde Vulkaner Festival',
    city: 'Vordingborg',
    region: 'Sjælland',
    startDate: '2026-07-01',
    endDate: '2026-07-04',
    approxVisitors: '11.000',
    website: 'https://www.vildevulkanerfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.008,
    lng: 11.9108,
  },
  {
    id: 'skagen-festival',
    name: 'Skagen Festival',
    city: 'Skagen',
    region: 'Jylland',
    startDate: '2026-07-03',
    endDate: '2026-07-06',
    approxVisitors: '15.000',
    website: 'https://skagenfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 57.7209,
    lng: 10.5839,
  },
  {
    id: 'copenhagen-jazz-festival',
    name: 'Copenhagen Jazz Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-07-01',
    endDate: '2026-07-10',
    approxVisitors: '250.000',
    website: 'https://jazz.dk',
    image: cityFestivalImage,
    genres: ['Jazz'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'vig-festival',
    name: 'Vig Festival',
    city: 'Vig',
    region: 'Sjælland',
    startDate: '2026-07-09',
    endDate: '2026-07-12',
    approxVisitors: '13.000',
    website: 'https://vigfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.8528,
    lng: 11.5948,
  },
  {
    id: 'summer-in-the-city-festival',
    name: 'Summer in the City Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-07-12',
    endDate: '2026-07-14',
    approxVisitors: null,
    website: 'https://www.facebook.com',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'femhoeje-festival',
    name: 'Femhøje Festival',
    city: 'Hjørring',
    region: 'Jylland',
    startDate: '2026-07-15',
    endDate: '2026-07-15',
    approxVisitors: '6.000',
    website: 'https://www.femhoeje.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 57.4635,
    lng: 9.9823,
  },
  {
    id: 'stjerner-over-faroe',
    name: 'Stjerner over Farø',
    city: 'Bogø',
    region: 'Sjælland',
    startDate: '2026-07-13',
    endDate: '2026-07-20',
    approxVisitors: null,
    website: 'https://xn--stjerneroverfar-kub.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 54.9375,
    lng: 12.0552,
  },
  {
    id: 'samsoe-festival',
    name: 'Samsø Festival',
    city: 'Samsø',
    region: 'Jylland',
    startDate: '2026-07-18',
    endDate: '2026-07-21',
    approxVisitors: '8.000',
    website: 'https://samfest.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.8222,
    lng: 10.6329,
  },
  {
    id: 'open-air-varde',
    name: 'Open Air Varde',
    city: 'Arnbjerg',
    region: 'Jylland',
    startDate: '2026-07-24',
    endDate: '2026-07-26',
    approxVisitors: '6.000',
    website: 'https://www.open-air.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.6211,
    lng: 8.4807,
  },
  {
    id: 'groen-koncert',
    name: 'Grøn Koncert',
    city: '8 forskellige byer',
    region: 'Flere landsdele',
    startDate: '2026-07-17',
    endDate: '2026-07-27',
    approxVisitors: '191.000',
    website: 'https://www.groenkoncert.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.2639,
    lng: 9.5018,
  },
  {
    id: 'nakkefestival',
    name: 'Nakkefestival',
    city: 'Rørvig',
    region: 'Sjælland',
    startDate: '2026-07-24',
    endDate: '2026-07-28',
    approxVisitors: '1.500',
    website: 'https://www.nakkefestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.9303,
    lng: 11.768,
  },
  {
    id: 'oe-festival',
    name: 'Ø Festival',
    city: 'Rudkøbing',
    region: 'Fyn',
    startDate: '2026-07-23',
    endDate: '2026-07-25',
    approxVisitors: '30.000',
    website: 'https://www.langelandsfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 54.9364,
    lng: 10.7102,
  },
  {
    id: 'alive-festival',
    name: 'Alive Festival',
    city: 'Thisted',
    region: 'Jylland',
    startDate: '2026-07-24',
    endDate: '2026-07-26',
    approxVisitors: '2.500',
    website: 'https://www.alivefestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.9552,
    lng: 8.6949,
  },
  {
    id: 'hansted-live',
    name: 'Hansted Live',
    city: 'Svendborg',
    region: 'Fyn',
    startDate: '2026-07-24',
    endDate: '2026-07-26',
    approxVisitors: '7.000',
    website: 'https://www.hanstedlive.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.0598,
    lng: 10.6068,
  },
  {
    id: 'mosstock-festival',
    name: 'Mosstock Festival',
    city: 'Skanderborg',
    region: 'Jylland',
    startDate: '2026-07-24',
    endDate: '2026-07-26',
    approxVisitors: '2.000',
    website: 'https://www.mosstock.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.0337,
    lng: 9.9278,
  },
  {
    id: 'sejeroe-festival',
    name: 'Sejerø Festival',
    city: 'Sejerø',
    region: 'Sjælland',
    startDate: '2026-07-24',
    endDate: '2026-07-26',
    approxVisitors: null,
    website: 'https://sejeroe.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.9004,
    lng: 11.1339,
  },
  {
    id: 'carpark-festival',
    name: 'Carpark Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-07-25',
    endDate: '2026-07-26',
    approxVisitors: '4.000',
    website: 'https://www.carparkfestival.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'nordlyd-festival',
    name: 'Nordlyd Festival',
    city: 'Roskilde',
    region: 'Sjælland',
    startDate: '2026-08-01',
    endDate: '2026-08-03',
    approxVisitors: '1.000',
    website: 'https://nordlydfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.6419,
    lng: 12.0803,
  },
  {
    id: 'grimfest',
    name: 'Grimfest',
    city: 'Aarhus',
    region: 'Jylland',
    startDate: '2026-08-01',
    endDate: '2026-08-03',
    approxVisitors: '2.500',
    website: 'https://grimfest.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 56.1629,
    lng: 10.2039,
  },
  {
    id: 'frederikssund-festival',
    name: 'Frederikssund Festival',
    city: 'Frederikssund',
    region: 'Sjælland',
    startDate: '2026-08-01',
    endDate: '2026-08-03',
    approxVisitors: '1.500',
    website: 'https://frederikssund-festival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.8396,
    lng: 12.0689,
  },
  {
    id: 'ringsted-festival',
    name: 'Ringsted Festival',
    city: 'Ringsted',
    region: 'Sjælland',
    startDate: '2026-08-01',
    endDate: '2026-08-03',
    approxVisitors: '12.000',
    website: 'https://www.ringstedfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.4426,
    lng: 11.7901,
  },
  {
    id: 'musik-over-praestoe-fjord',
    name: 'Musik over Præstø Fjord',
    city: 'Tappernøje',
    region: 'Sjælland',
    startDate: '2026-08-01',
    endDate: '2026-08-04',
    approxVisitors: '300',
    website: 'https://www.mopf.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.1662,
    lng: 11.9818,
  },
  {
    id: 'new-note-festival',
    name: 'New Note Festival',
    city: 'Hillerød',
    region: 'Hovedstaden',
    startDate: '2026-08-02',
    endDate: '2026-08-03',
    approxVisitors: '500',
    website: 'https://www.newnotefestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.9279,
    lng: 12.3008,
  },
  {
    id: 'stroem-festival',
    name: 'Strøm Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-08-02',
    endDate: '2026-08-05',
    approxVisitors: '15.000',
    website: 'https://www.stromcph.dk',
    image: cityFestivalImage,
    genres: ['Elektronisk', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'o-day-fest',
    name: 'O / Day Fest',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-08-01',
    endDate: '2026-08-03',
    approxVisitors: null,
    website: 'https://o-dayfest.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'aia-sound-festival',
    name: 'Aia Sound Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-08-01',
    endDate: '2026-08-03',
    approxVisitors: '30.000',
    website: 'https://www.aiasound.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Storbyfestival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'jels-fest',
    name: 'Jels Fest',
    city: 'Rødding',
    region: 'Jylland',
    startDate: '2026-08-02',
    endDate: '2026-08-02',
    approxVisitors: null,
    website: 'https://www.jelsfest.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.3659,
    lng: 9.0632,
  },
  {
    id: 'surround-festival',
    name: 'Surround Festival',
    city: 'Roskilde',
    region: 'Sjælland',
    startDate: '2026-05-17',
    endDate: '2026-05-18',
    approxVisitors: null,
    website: 'https://www.surroundfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.6419,
    lng: 12.0803,
  },
  {
    id: 'kalundborg-rocker',
    name: 'Kalundborg Rocker',
    city: 'Kalundborg',
    region: 'Sjælland',
    startDate: '2026-08-08',
    endDate: '2026-08-10',
    approxVisitors: '21.000',
    website: 'https://www.kalundborg-rocker.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 55.6795,
    lng: 11.0886,
  },
  {
    id: 'rock-ved-ruinen',
    name: 'Rock Ved Ruinen',
    city: 'Gilleleje',
    region: 'Hovedstaden',
    startDate: '2026-08-08',
    endDate: '2026-08-10',
    approxVisitors: null,
    website: 'https://rockvedruinen.dk',
    image: rockFestivalImage,
    genres: ['Rock'],
    featured: false,
    lat: 56.1212,
    lng: 12.3108,
  },
  {
    id: 'jyllinge-festival',
    name: 'Jyllinge Festival',
    city: 'Jyllinge',
    region: 'Sjælland',
    startDate: '2026-08-15',
    endDate: '2026-08-16',
    approxVisitors: null,
    website: 'https://www.jyllingefestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.752,
    lng: 12.1049,
  },
  {
    id: 'uhoert-festival',
    name: 'Uhørt Festival',
    city: 'København',
    region: 'Hovedstaden',
    startDate: '2026-08-17',
    endDate: '2026-08-19',
    approxVisitors: '2.000',
    website: 'https://www.uhoert.dk',
    image: cityFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.6761,
    lng: 12.5683,
  },
  {
    id: 'suset-esbjerg',
    name: 'Suset Esbjerg',
    city: 'Esbjerg',
    region: 'Jylland',
    startDate: '2026-08-22',
    endDate: '2026-08-23',
    approxVisitors: null,
    website: 'https://www.suset.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.4765,
    lng: 8.4594,
  },
  {
    id: 'lydfest',
    name: 'Lydfest',
    city: 'Birkerød',
    region: 'Hovedstaden',
    startDate: '2026-08-24',
    endDate: '2026-08-24',
    approxVisitors: null,
    website: 'https://www.lydfest.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.8486,
    lng: 12.4279,
  },
  {
    id: 'gjoelen-festival',
    name: 'Gjølen Festival',
    city: 'Aabybro',
    region: 'Jylland',
    startDate: '2026-08-24',
    endDate: '2026-08-25',
    approxVisitors: '1.500',
    website: 'https://gjoelenfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 57.1625,
    lng: 9.7303,
  },
  {
    id: 'midtfyns-festival',
    name: 'Midtfyns Festival',
    city: 'Ringe',
    region: 'Fyn',
    startDate: '2026-09-04',
    endDate: '2026-09-06',
    approxVisitors: '2.000',
    website: 'https://www.midtfynsfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.238,
    lng: 10.4786,
  },
  {
    id: 'generator-festival',
    name: 'Generator Festival',
    city: 'Odense',
    region: 'Fyn',
    startDate: '2026-09-07',
    endDate: '2026-09-08',
    approxVisitors: '19.000',
    website: 'https://generatorfestival.dk',
    image: genericFestivalImage,
    genres: ['Musik', 'Festival'],
    featured: false,
    lat: 55.4038,
    lng: 10.4024,
  },
];

export const featuredFestivals = festivals.filter((festival) => festival.featured);

export const groupFestivalsByMonth = (festivalList) =>
  monthNames
    .map((month) => ({
      month,
      festivals: festivalList.filter(
        (festival) => getMonthLabelFromDate(festival.startDate) === month
      ),
    }))
    .filter((group) => group.festivals.length > 0);
